import React from "react";

const ExtraSVGIcons = ({ size = 15, color = "#ffffff", type = "" }) => {
  return (
    <>
      {type === "historyBack" ? (
        <svg width={size} height={size} viewBox="0 0 512.052 512.052" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g fill={color} xmlns="http://www.w3.org/2000/svg">
                <g>
                    <path d="M510.207,414.676c-2.32-23.264-6.805-47.255-14.019-71.608C461.49,226.023,355.26,143.933,234.667,138.804V53.362    c0-19.006-22.979-28.524-36.418-15.085l-192,192c-8.331,8.331-8.331,21.839,0,30.17l192,192    c13.439,13.439,36.418,3.921,36.418-15.085V327.656c48.213-4.823,103.873,7.119,157.335,48.352    c29.572,22.808,56.566,53.666,80.333,93.599C483.421,488.234,512,480.372,512,458.696c0.005-0.959,0.005-0.959,0.025-2.725    C512.165,442.689,511.785,430.503,510.207,414.676z M418.059,342.222c-66.551-51.328-136.755-64.332-197.184-55.876    c-5.85,0.818-10.162,1.676-12.758,2.331c-9.476,2.39-16.117,10.913-16.117,20.686v76.497L51.503,245.362L192,104.866v55.163    c0,12.07,10.005,21.737,22.069,21.321c0.863-0.03,1.551-0.045,3.33-0.076c108.78-2.351,206.919,69.472,237.882,173.917    c2.832,9.56,5.193,19.068,7.124,28.488C448.369,367.975,433.564,354.18,418.059,342.222z"/>
                </g>
            </g>
        </svg>
      ) : type === "listMenu" ? (
        <svg width={size} height={size} viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill="none" d="M6.91071 12.9352V18.2189C6.91071 18.8001 6.44115 19.2756 5.86724 19.2756H2.73683C2.16292 19.2756 1.69336 18.8001 1.69336 18.2189V10.8217V7.97011L8.29852 1.94507C8.69504 1.58578 9.30025 1.58578 9.69677 1.94507L16.3019 7.97011V10.8217V18.2189C16.3019 18.8001 15.8324 19.2756 15.2585 19.2756H12.1281C11.5542 19.2756 11.0846 18.8001 11.0846 18.2189V12.9352H6.91071Z" stroke="white" strokeOpacity="0.9" strokeWidth="2"/>
        </svg>
      ) : null}
    </>
  );
};

export default ExtraSVGIcons;
